export enum CreatePermanentJobPostingSteps {
  BasicInformation = 'basic-information',
  JobDescription = 'job-description',
  ReviewAndPayment = 'review-and-payment',
  WorkDetails = 'work-details',
}

export enum CreatePermanentJobPostingFormSection {
  EarningsAndBenefits = 'earnings-and-benefits',
  GeneralJobInformation = 'general-job-information',
  JobDescription = 'job-description',
  Schedule = 'schedule',
}

export type TCreatePermanentJobPostingPageRoutes = { id?: string };

export type TCreatePermanentJobPostingPageLocationState = {
  editMode?: boolean;
  scrollTo?: CreatePermanentJobPostingFormSection;
};
